import '@fancyapps/fancybox'

$(function () {
  $('[data-fancybox]').fancybox({
    buttons: ['slideShow', 'fullScreen', 'download', 'thumbs', 'close'],
    beforeShow: function() {
      $('.caption--image').remove();
    },
    afterShow: function() {
      var caption = $(".fancybox-caption"),
          innerCaption = caption.clone().addClass('caption--image');

      $(".fancybox-slide--current .fancybox-content").append(innerCaption);
      caption.not('.caption--image').addClass('caption--bottom');
  }
  })
})
